import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { logEvent } from '../utils/logEvent'; // ✅ Adjust this path if needed

const Home = () => {
  useEffect(() => {
    logEvent('visit_homepage');
  }, []);

  return (
    <main className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-100 p-6">
      {/* Hero Section */}
      <section className="max-w-6xl mx-auto py-20 text-center">
        <h1 className="text-5xl font-extrabold text-indigo-800 mb-4">
          EmpowerHer Digital Literacy Program
        </h1>
        <p className="text-xl text-gray-700 mb-8">
          Empowering African women and girls with the digital skills to thrive in the 21st century. Build your foundation today and unlock a future in tech.
        </p>
        <div className="space-x-4">
          <Link
            to="/register"
            className="bg-indigo-700 hover:bg-indigo-800 text-white font-semibold py-3 px-6 rounded-xl shadow transition"
          >
            Enroll Now
          </Link>
          <Link
            to="/courses"
            className="bg-white hover:bg-indigo-100 text-indigo-700 font-semibold py-3 px-6 rounded-xl border border-indigo-700 shadow-sm transition"
          >
            Browse Courses
          </Link>
        </div>
      </section>

      {/* Initiative Overview Section */}
      <section className="max-w-6xl mx-auto py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 text-center">
        <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
          <h3 className="text-lg font-bold text-indigo-700 mb-2">Empowerment Through Skills</h3>
          <p className="text-gray-600">Develop digital confidence with essential tech knowledge—from internet use to online safety and productivity tools.</p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
          <h3 className="text-lg font-bold text-indigo-700 mb-2">From Basics to Careers</h3>
          <p className="text-gray-600">Start with EmpowerHer, then explore Girls-To-Tech to dive deeper into tech careers like Cloud, Data Science, and Cybersecurity.</p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
          <h3 className="text-lg font-bold text-indigo-700 mb-2">Join a Growing Community</h3>
          <p className="text-gray-600">Be part of a movement shaping Africa’s future in tech. Connect, learn, and grow with mentors and peers.</p>
        </div>
      </section>

      {/* Impact Callout */}
      <section className="bg-indigo-50 py-12 mt-8 text-center rounded-xl shadow-inner">
        <h2 className="text-2xl font-bold text-indigo-800 mb-4">Pilot Program Running in Kenya 🇰🇪</h2>
        <p className="text-gray-700">We’re starting local and scaling continental. Join now and become part of our digital transformation story.</p>
      </section>
    </main>
  );
};

export default Home;
